import { createSelector } from 'reselect';
import { getShouldUseTwoHourSoonLoggedInThreshold } from 'flow/selectors/selectors';

const TEN_MINUTES = 1000 * 60 * 10;
const TWO_HOURS = 1000 * 60 * 120;

export const getQueueMembersSoonLoggedInThreshold = createSelector(
    [getShouldUseTwoHourSoonLoggedInThreshold],
    (shouldUseTwoHourThreshold) => {
        return shouldUseTwoHourThreshold ? TWO_HOURS : TEN_MINUTES;
    },
);
